import { render } from "./ListeDocumentPage.vue?vue&type=template&id=04120b5e&ts=true"
import script from "./ListeDocumentPage.vue?vue&type=script&lang=ts"
export * from "./ListeDocumentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__